module.exports = __webpack_public_path__ + "static/media/Calendar.d1fa4037.svg";